import axios from "axios";
import { UrlFilterHelper } from "../_helpers/UrlFilterHelper";
const API_URL = process.env.REACT_APP_API_URL;
const SEARCH_CONTROLLER = "/Search/";
const SEARCH_ALL_URL = API_URL + SEARCH_CONTROLLER + "SearchAllAsync";

export const SearchApi = {
    searchAll,
};

function searchAll(skipCount, search, size) {
    var url = UrlFilterHelper.GetFilterdUrl(SEARCH_ALL_URL, skipCount, encodeURIComponent(search), null, null, size);
    return axios.get(url);  // Returns: PagedResultDto<SearchResultItemDto>
}